export default __webpack_public_path__ + "static/media/her.221eef88.jpg";